import { Reorder, useDragControls } from "motion/react";

function ItemRow({
  item,
  onToggle,
  onDragEnd,
}) {
  const dragControls = useDragControls();
  const priceDisplay =
    item.price?.length > 0
      ? item.price.map((p) => `$${Number(p).toFixed(2)}`).join(" / ")
      : "—";

  return (
    <Reorder.Item
      as="div"
      value={item._id}
      dragListener={false}
      dragControls={dragControls}
      onDragEnd={onDragEnd}
      className="cms-item-rowwrap"
    >
      <span
        className="cms-drag-handle"
        aria-label="Drag to reorder"
        onPointerDown={(e) => {
          e.preventDefault();
          dragControls.start(e);
        }}
      >
        <svg width="10" height="14" viewBox="0 0 10 14" fill="currentColor">
          <circle cx="2.5" cy="2" r="1.3" />
          <circle cx="7.5" cy="2" r="1.3" />
          <circle cx="2.5" cy="7" r="1.3" />
          <circle cx="7.5" cy="7" r="1.3" />
          <circle cx="2.5" cy="12" r="1.3" />
          <circle cx="7.5" cy="12" r="1.3" />
        </svg>
      </span>
      <button className="cms-table-row" role="row" onClick={onToggle}>
        <span className="cms-row-name" role="cell">
          {item.name}
        </span>
        <span className="cms-row-desc" role="cell" title={item.description}>
          {item.description || ""}
        </span>
        <span className="cms-row-price" role="cell">
          {priceDisplay}
        </span>
        <span className="cms-row-chevron" aria-hidden="true">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </span>
      </button>
    </Reorder.Item>
  );
}

export default ItemRow;
